/* Butler Loftet — mobile drill-down menu navigation */
(function () {
  'use strict';

  function initMenu(menu) {
    if (!menu || menu.dataset.blMenuInit === 'true') return;
    menu.dataset.blMenuInit = 'true';

    var viewport = menu.querySelector('.bl-menu__viewport');
    var panels = Array.prototype.slice.call(menu.querySelectorAll('.bl-menu__panel'));
    if (!viewport || !panels.length) return;

    var stack = ['root'];

    function panelById(id) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-panel-id') === id) return panels[i];
      }
      return null;
    }

    function render() {
      var currentId = stack[stack.length - 1];
      panels.forEach(function (p) {
        var id = p.getAttribute('data-panel-id');
        var isActive = id === currentId;
        p.classList.toggle('is-active', isActive);
        p.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      menu.setAttribute('data-depth', String(stack.length - 1));
    }

    function goTo(id) {
      if (!panelById(id)) return;
      // If id already in the stack (breadcrumb back), trim to it; else push.
      var idx = stack.indexOf(id);
      if (idx !== -1) {
        stack = stack.slice(0, idx + 1);
      } else {
        stack.push(id);
      }
      render();
      viewport.scrollTop = 0;
      var active = panelById(id);
      if (active) {
        var list = active.querySelector('.bl-menu__list');
        if (list) list.scrollTop = 0;
      }
    }

    function reset() {
      stack = ['root'];
      menu.querySelectorAll('.bl-menu__group.is-open').forEach(function (g) {
        g.classList.remove('is-open');
        var btn = g.querySelector('[data-accordion-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      render();
    }

    menu.addEventListener('click', function (e) {
      // Accordion toggle (level 1 -> expand its children inline).
      var acc = e.target.closest('[data-accordion-toggle]');
      if (acc && menu.contains(acc)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var group = acc.closest('.bl-menu__group');
        var isOpen = group.classList.contains('is-open');
        // Close any other open accordion (single-open behaviour).
        menu.querySelectorAll('.bl-menu__group.is-open').forEach(function (g) {
          if (g !== group) {
            g.classList.remove('is-open');
            var btn = g.querySelector('[data-accordion-toggle]');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });
        group.classList.toggle('is-open', !isOpen);
        acc.setAttribute('aria-expanded', String(!isOpen));
        return;
      }

      // Drill into a sub-panel (level 2 -> level 3, with breadcrumb).
      var trigger = e.target.closest('[data-open-panel]');
      if (trigger && menu.contains(trigger)) {
        // Stop the theme's generic button/summary handlers (which close the
        // whole drawer) from running.
        e.preventDefault();
        e.stopImmediatePropagation();
        goTo(trigger.getAttribute('data-open-panel'));
        return;
      }

      // Current breadcrumb crumb is inert — block theme close handler.
      var current = e.target.closest('.bl-menu__crumb--current');
      if (current && menu.contains(current)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    // Reset to the root level whenever the drawer is closed.
    var wrapper = menu.closest('.mobile-toggle-wrapper');
    if (wrapper) {
      var observer = new MutationObserver(function () {
        if (!wrapper.hasAttribute('open') && !wrapper.classList.contains('active')) {
          reset();
        }
      });
      observer.observe(wrapper, { attributes: true, attributeFilter: ['open', 'class'] });
    }

    render();
    menu.blMenuReset = reset;
  }

  function initAll() {
    document.querySelectorAll('.bl-menu').forEach(initMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
